// @flow
import React, { useState, useMemo } from 'react';
import classNames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import replace from 'ramda/es/replace';

import { DotsLoader } from 'app/common/components/Loader';
import { priceTypes, type PriceDiscountedRequestParams } from 'app/common/api/general.types/tariff.pricediscounted';
import toFixedValue from 'app/common/lib/toFixedValue';

import usePriceDiscounted from './usePriceDiscounted';
import styles from './PriceDiscounted.scss';


type Props = {
  className?: string,
  studentId: number,
  tariffId: number,
  informersState: {
    lk_enabled: boolean,
    mobile_enabled: boolean,
  }
}

const PriceDiscountedConstruct = ({
  className,
  studentId,
  tariffId,
  informersState,
}: Props) => {
  const [autoload, setAutoload] = useState(false);

  const paramsLk: PriceDiscountedRequestParams = useMemo(() => ({
    student_id: studentId,
    tariff_id: tariffId,
    price_type: priceTypes.price_lk,
  }), [studentId, tariffId]);

  const paramsMobile: PriceDiscountedRequestParams = useMemo(() => ({
    student_id: studentId,
    tariff_id: tariffId,
    price_type: priceTypes.price_lk,
  }), [studentId, tariffId]);

  const [priceLk, loadingLk] = usePriceDiscounted(paramsLk, autoload);
  const [priceMobile, loadingMobile] = usePriceDiscounted(paramsMobile, autoload);


  const loading = loadingLk || loadingMobile;
  const price = useMemo(() => {
    const { lk_enabled: lkEnabled, mobile_enabled: mobileEnabled } = informersState;
    const lkPrice = lkEnabled ? parseFloat(priceLk) : 0;
    const mobilePrice = mobileEnabled ? parseFloat(priceMobile) : 0;
    return replace(/^\d+\.\d+/, toFixedValue(lkPrice + mobilePrice), priceLk || '');
  }, [informersState, priceLk, priceMobile]);


  return (
    <VisibilitySensor
      onChange={setAutoload}
      scrollCheck
      delayedCall
      partialVisibility
    >
      {loading
        ? <DotsLoader simple />
        : <span className={classNames(styles.root, className)}>
          {price || '???'}
        </span>}
    </VisibilitySensor>
  );
};

export default PriceDiscountedConstruct;
